"use client";

import type { SignUpPopoverProps } from "@ui/components/core/SignUpPopover";

import { SignUpPopover } from "@ui/components/core/SignUpPopover";
import { MusicPopoverCover } from "@ui/components/music/MusicPopoverCover";
import IconStar from "@ui/central-icons/icons/IconStar";
import IconArrowInbox from "@ui/central-icons/icons/IconArrowInbox";
import IconWriting from "@ui/central-icons/icons/IconWriting";
import { iconStrokeFix } from "@ui/central-icons/iconUtils";
import { cn } from "@ui/lib/utils";

import musicPopoverCover from "./images/music_popup_cover.jpg";

interface MusicSignUpPopoverSectionProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  ctaText: string;
  ctaHref: string;
  features: [string, ...string[]];
  ctaEventName?: SignUpPopoverProps["ctaEventName"];
  categoryName?: string;
}

export function MusicSignUpPopoverSection({
  isOpen,
  onOpenChange,
  title,
  ctaText,
  ctaHref,
  features,
  ctaEventName,
  categoryName,
}: MusicSignUpPopoverSectionProps) {
  const featureItems: [{ icon: React.ReactNode; text: string }, ...{ icon: React.ReactNode; text: string }[]] = [
    { icon: <IconWriting className={cn(iconStrokeFix, "tw-size-[18px]")} />, text: features[0] },
    { icon: <IconStar className={cn(iconStrokeFix, "tw-size-[18px]")} />, text: features[1] },
    { icon: <IconArrowInbox className={cn(iconStrokeFix, "tw-size-[18px]")} />, text: features[2] },
  ];

  return (
    <SignUpPopover
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      cover={<MusicPopoverCover categoryName={categoryName} categoryImageUrl={musicPopoverCover.src} />}
      title={title}
      featureItems={featureItems}
      ctaText={ctaText}
      ctaHref={ctaHref}
      ctaEventName={ctaEventName}
    />
  );
}
